﻿<script setup lang="ts">
    import { ref, onMounted, computed } from 'vue';
    import { chainComparers } from '@/shared/helpers/utils';
    import {
        Scope,
        ScopeSelectorSelectionMode,
        compareByIsInSet,
        compareByIdentity
    } from '@/shared/components/scopeselector/scopeSelectionHelper.ts';
    import ScopeSelectorBase from '@/shared/components/scopeselector/ScopeSelectorBase.vue';

    type Props = {
        scopes: Scope[];
        disabledScopes?: string[];
    };

    const props = withDefaults(defineProps<Props>(), {
        disabledScopes: () => []
    });

    const pinnedScopes = defineModel<string[]>('pinnedScopes', { required: false });
    const selectedScope = defineModel<string | null>('selectedScope', { required: false });

    const sortedScopesOnLoad = ref<Scope[]>([]);

    const pinnedScopesSet = computed(() => new Set<string>(pinnedScopes.value ?? []));

    function compareByIsPinned(a: Scope, b: Scope): number {
        return compareByIsInSet(a, b, pinnedScopesSet.value);
    }

    function compareByIsSelected(a: Scope, b: Scope): number {
        if (selectedScope.value === null) {
            return 0;
        }

        const isSelectedA = a.identity === selectedScope.value;
        const isSelectedB = b.identity === selectedScope.value;

        if (isSelectedA && !isSelectedB) return -1;
        if (!isSelectedA && isSelectedB) return 1;
        return 0;
    }

    onMounted(() => {
        sortedScopesOnLoad.value = [...props.scopes].sort(chainComparers(compareByIsSelected, compareByIsPinned, compareByIdentity));
    });
</script>

<template>
    <scope-selector-base
        v-model:pinned-scopes="pinnedScopes"
        v-model:selected-scope="selectedScope"
        :scopes="sortedScopesOnLoad"
        :disabled-scopes="props.disabledScopes"
        :enable-pinning="true"
        :enable-row-selection="true"
        :selection-mode="ScopeSelectorSelectionMode.Single"
        :selected-scopes="[]"
        :hoverable="true" />
</template>

<style scoped>

</style>
